import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiSession } from '@brighthub/uisession';
import { CopilotFacadeService } from '@brighthub/copilot';
import { ConversationInfoComponent } from '../conversation-info/conversation-info.component';
import { Router } from '@angular/router';
import { ConversationService } from '../conversation.service';

@Component({
  selector: 'lib-conversation-search-result-wrapper',
  imports: [CommonModule, ConversationInfoComponent],
  templateUrl: './conversation-search-result-wrapper.component.html',
  styleUrl: './conversation-search-result-wrapper.component.scss',
})
export class ConversationSearchResultWrapperComponent {
  @Input() data!: UiSession;
  @Input() providerId!: string;

  private _router = inject(Router);
  readonly conversationService = inject(ConversationService);

  selectConversation(conversation: UiSession) {
    this.conversationService.setActiveConversation(conversation);
    this._router.navigate([`/brightai/conversation/${conversation.conversationId}`]);
  }

}
